import React from 'react';
import PropTypes from 'prop-types';
import CountrySelectorButton from '@cotyorg/ccx-organism-country-selector/CountrySelectorButton';
import { CountrySelector } from '@cotyorg/ccx-organism-country-selector';
import FooterList from '../FooterList/FooterList';
import Copyright from '../Copyright/Copyright';

const FooterStreamlined = ({
  footer,
  showCountrySelector = false,
  headingLevel = 5,
}) => {
  const { copyright } = footer;
  const { text } = copyright;

  return (
    <footer className="footer">
      <FooterList
        disableNesting
        footer={footer}
        extraClass="footer-list--streamlined"
        extraNavClass="footer-streamlined__nav"
        extraNavListClass="footer-streamlined__nav-list"
        extraNavListItemClass="footer-streamlined__nav-item"
        extraNavLinkClass="footer-streamlined__nav-link"
        extraChildrenWrapperClass="footer-streamlined__nav-item"
        headingLevel={headingLevel}
        addChildrenAsLinks
      >
        {
          showCountrySelector && (
            <CountrySelectorButton extraClass="footer-streamlined__country-selector-button" />
          )
        }
      </FooterList>
      { showCountrySelector && <CountrySelector /> }
      <Copyright text={text} extraClass="copyright__message--streamlined" />
    </footer>
  );
};

FooterStreamlined.propTypes = {
  footer: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    copyright: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  showCountrySelector: PropTypes.bool,
  headingLevel: PropTypes.number,
};

export default FooterStreamlined;
